export default __webpack_public_path__ + "static/logo-8f858893f21c4bf03361ca19d4ddb745.svg";